import { apiRoutes } from "../Constant/ApiRoutes";
import { getRequest } from "../apiRequest";

export const getUsersList = () => {
  return getRequest(apiRoutes.kbUsers);
};
